import loadCopys from "../../../base/services/consorcio.i18n";
import CustomModal from "../../../base/components/modal";
import DateP from "../../../base/components/datePicker";

import "../index.less";

class ReporteAsegurabilidad extends React.Component {
  constructor() {
    super();
    this.state = {
      currentDate: "",
      initDate: "",
      finalDate: "",
      documentType: "",
      numberDocument: "",
      typeDocList: [],
      searchType: "date",
      showError: false
    };

    loadCopys("cicloVentaAfiliacion/reporteAsegurabilidad/text.js");
    this.pnpService = new ServicioPnp();
    this.handleSwitchSelect = this.handleSwitchSelect.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
  }

  componentDidMount() {
    this.pnpService.getList(
      "tiposDocumento",
      typeDocList => {
        this.setState({ typeDocList });
      },
      null,
      "CSIdDocumentoText",
      "CSSiglaText",
      "CSDocumentoIdentidadText"
    );
    this.getFinalDateSelected();
  }

  getFinalDateSelected = date => {
    const finalDate = moment(date).format("DD/MM/YYYY");
    const initDate = moment(date)
      .subtract(6, "month")
      .format("DD/MM/YYYY");
    this.setState({ initDate, finalDate });
  };

  handleDropdown(selected) {
    const documentType = selected;
    this.setState({ documentType });
  }

  handleTextInputChange(e) {
    const numberDocument = e.target.value;
    this.setState({ numberDocument });
  }

  handleSwitchSelect(e, field) {
    this.setState({ searchType: field });
  }

  downloadFile() {
    const initDate = this.state.initDate; //moment(this.state.initDate, "DD/MM/YYYY").format("YYYY-MM-DD");
    const finalDate = this.state.finalDate; //moment(this.state.finalDate, "DD/MM/YYYY").format("YYYY-MM-DD");
    const documentTypeId = this.state.typeDocList.filter(
      item => item.CSDocumentoIdentidadText === this.state.documentType
    );
    const getFile =
      this.state.searchType === "date"
        ? new ServicioProxy(
            `GenerarReporteAsegurabilidad?fechaInicio=${initDate}&fechaFin=${finalDate}`,
            "ServicioConsorcio.svc"
          )
        : new ServicioProxy(
            `GenerarReporteAsegurabilidad?tipoIdentificacion=${
              documentTypeId[0].CSIdDocumentoText
            }&numeroDocumento=${this.state.numberDocument}`,
            "ServicioConsorcio.svc"
          );

    getFile
      .getElements("POST", {})
      .then(response => {
        const data = JSON.parse(response);
        if (data.Error && data.Error.CodigoStatusError) {
          throw data.Error;
        }
        const isIE =
          window.navigator.userAgent.includes("Trident/7.0") ||
          window.navigator.userAgent.includes("Edge");
        if (!isIE) {
          const file = document.createElement("a");
          file.href =
            "data:application/vnd.ms-excel;base64," + data.Base64Documento;
          file.download = data.NombreDocumento;
          document.body.appendChild(file);
          file.click();
          document.body.removeChild(file);
        } else {
          const binary = atob(data.Base64.replace(/\s/g, ""));
          const buffer = new ArrayBuffer(binary.length);
          const view = new Uint8Array(buffer);
          for (let i = 0; i < binary.length; i++) {
            view[i] = binary.charCodeAt(i);
          }
          const blob = new Blob([view], { type: "application/vnd.ms-excel" });
          navigator.msSaveBlob(blob, data.NombreDocumento);
        }
      })
      .catch(error => {
        this.setState({ showError: true });
      });
    this.setState({ documentType: "", numberDocument: "" });
  }

  renderGeneralModal() {
    return (
      <CustomModal
        ref='generalModal'
        showModal={true}
        RightButtonAction={this.handleModalClose.bind(this)}
      />
    );
  }
  handleModalClose() {
    this.setState({ showError: false });
  }

  render() {
    const {
      documentType,
      numberDocument,
      initDate,
      finalDate,
      typeDocList,
      searchType
    } = this.state;

    const dateFormatted = moment(finalDate, "DD/MM/YYYY").format("MM/DD/YYYY");
    return (
      <div className='insurability-report-container'>
        {this.state.showError && this.renderGeneralModal()}
        {!deviceDetector.isMobile ? (
          <div>
            <div className='title'>
              <h1 className='title'>{i18next.t("title")}</h1>
            </div>
            <div className='choice-menu'>
              <div className='date-search col-md-6'>
                <div className='form-group'>
                  <label className='col-md-6 control-label date-selected text-right'>
                    {i18next.t("busquedaFecha")}
                  </label>
                  <input
                    type='radio'
                    className='col-md-1'
                    name='select-type'
                    onClick={e => this.handleSwitchSelect(e, "date")}
                    defaultChecked
                  />
                </div>
              </div>
              <div className='document-search col-md-6'>
                <div className='form-group'>
                  <label className='col-md-6 control-label document-selected text-right'>
                    {i18next.t("busquedaDocumento")}
                  </label>
                  <input
                    type='radio'
                    className='col-md-1'
                    name='select-type'
                    onClick={e => this.handleSwitchSelect(e, "document")}
                  />
                </div>
              </div>
            </div>
            <form className='form-horizontal'>
              {searchType === "date" ? (
                <div className='date-search'>
                  <div className='form-group col-sm-6'>
                    <label className='control-label col-sm-5'>
                      {i18next.t("fechaInicio")}
                    </label>
                    <div className='col-sm-6'>
                      <DateP
                        isRequired={true}
                        currentDate={initDate}
                        getDateSelected={this.getInitialDateSelected}
                        maxDate={new Date(dateFormatted)}
                        containerClasses='col-sm-12'
                      />
                    </div>
                  </div>
                  <div className='form-group col-sm-6'>
                    <label className='control-label col-sm-5'>
                      {i18next.t("fechaFin")}
                    </label>
                    <div className='col-sm-6'>
                      <DateP
                        isRequired={true}
                        currentDate={finalDate}
                        getDateSelected={this.getFinalDateSelected}
                        maxDate={new Date()}
                        containerClasses='col-sm-12'
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className='document-search'>
                  <div className='form-group col-sm-6'>
                    <label className='control-label col-sm-5'>
                      {i18next.t("tipoDocumento")}
                    </label>
                    <div className='col-sm-6'>
                      <DropdownButton
                        title={
                          documentType !== "" ? documentType : "Seleccionar"
                        }
                        className='dropdown-custom'
                        bsStyle='Primary'
                        onSelect={value => this.handleDropdown(value)}
                        value={documentType}
                      >
                        {typeDocList.map((item, key) => {
                          return (
                            <MenuItem
                              key={key}
                              eventKey={item.CSDocumentoIdentidadText}
                            >
                              {item.CSDocumentoIdentidadText}
                            </MenuItem>
                          );
                        })}
                      </DropdownButton>
                    </div>
                  </div>
                  <div className='form-group col-sm-6'>
                    <label className='control-label col-sm-5'>
                      {i18next.t("numeroDocumento")}
                    </label>
                    <div className='col-sm-6'>
                      <input
                        type='text'
                        className='form-control'
                        onChange={e => this.handleTextInputChange(e)}
                        value={numberDocument}
                      />
                    </div>
                  </div>
                </div>
              )}
            </form>
            <div className='clearfix' />
            <div className='download-report text-center'>
              {(searchType === "date" && initDate !== "" && finalDate !== "") ||
              (searchType === "document" &&
                documentType !== "" &&
                numberDocument !== "") ? (
                <button
                  type='button'
                  className='btn btn-default'
                  onClick={this.downloadFile}
                >
                  {i18next.t("descargaReporte")}
                </button>
              ) : (
                <button type='button' className='btn btn-disabled' disabled>
                  {i18next.t("descargaReporte")}
                </button>
              )}
            </div>
          </div>
        ) : (
          <div>
            <h2 className='no-mobile-msg'>{i18next.t("noMobileMsg")}</h2>
          </div>
        )}
      </div>
    );
  }
}

// const Table = ReactBootstrap.Table;
const DropdownButton = ReactBootstrap.DropdownButton;
const MenuItem = ReactBootstrap.MenuItem;
const Button = ReactBootstrap.Button;
// const Popover = ReactBootstrap.Popover;
const OverlayTrigger = ReactBootstrap.OverlayTrigger;

const appId = document.getElementById("insurability-report");
ReactDOM.render(<ReporteAsegurabilidad />, appId);



// WEBPACK FOOTER //
// ./cicloVentaAfiliacion/reporteAsegurabilidad/src/index.js